(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBars = document.querySelectorAll('.announcement-bar');

  announcementBars.forEach((bar) => {
    const content = bar.querySelector('.announcement-bar__content');
    const track = bar.querySelector('.announcement-bar__track');
    const firstGroup = track && track.querySelector('.announcement-bar__group');

    if (!content || !track || !firstGroup) return;

    const pxPerSecond = 80;

    const setupMarquee = () => {
      const groupWidth = firstGroup.getBoundingClientRect().width;
      const contentWidth = content.getBoundingClientRect().width;

      if (groupWidth <= 0 || contentWidth <= 0) return;

      // Ensure enough repeated content to avoid any visible blank area.
      while (track.scrollWidth < contentWidth + groupWidth) {
        const clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      track.style.setProperty('--marquee-distance', `${groupWidth}px`);
      track.style.setProperty('--marquee-duration', `${groupWidth / pxPerSecond}s`);
    };

    setupMarquee();
    window.addEventListener('resize', setupMarquee);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const DEBOUNCE_MS = 500;

    async function refreshCartFragment() {
      try {
        const res = await fetch('/cart');
        if (!res.ok) return;
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCart = doc.querySelector('.cart-page');
        const oldCart = document.querySelector('.cart-page');
        if (newCart && oldCart) {
          oldCart.replaceWith(newCart);
        }
      } catch (e) {
        // fail silently
        console.error('Failed to refresh cart fragment', e);
      }
    }

    function initCartQuantityControls(scope = document) {
      const cartPage = scope.querySelector('.cart-page');
      if (!cartPage) return;

      const cartForm = cartPage.querySelector('form.cart-layout');

      const scheduleSubmit = (input) => {
        if (!input) return;

        if (input.dataset.updateTimerId) {
          clearTimeout(Number(input.dataset.updateTimerId));
        }
        const id = setTimeout(async () => {
          // perform AJAX update for this single line using the input's name
          try {
            const params = new URLSearchParams();
            params.append(input.name, input.value);

            const res = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: params.toString(),
            });

            if (res.ok) {
              // refresh cart fragment to show updated totals and lines
              await refreshCartFragment();
              // re-initialize controls on the replaced fragment
              initCartQuantityControls(document);
            }
          } catch (err) {
            console.error('Cart update failed', err);
          }
        }, DEBOUNCE_MS);
        input.dataset.updateTimerId = String(id);
      };

      cartPage.querySelectorAll('.cart-quantity').forEach((quantityControl) => {
        const input = quantityControl.querySelector('.cart-quantity__input');
        const buttons = quantityControl.querySelectorAll('.cart-quantity__button');

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            if (!input) return;
            const step = Number(button.dataset.quantityStep || 0);
            const currentValue = Number(input.value || 0);
            const nextValue = Math.max(0, currentValue + step);
            input.value = nextValue;
            scheduleSubmit(input);
          });
        });

        if (input) {
          input.addEventListener('input', () => {
            const val = Number(input.value || 0);
            if (Number.isNaN(val) || val < 0) return;
            scheduleSubmit(input);
          });
          input.addEventListener('change', () => scheduleSubmit(input));
        }
      });
    }

    // initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCartQuantityControls(document));
    } else {
      initCartQuantityControls(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-product-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
'use strict';

// ── Type filters (non-core collections) ─────────────────────────
document.querySelectorAll('[data-featured-collection-grid]').forEach((grid) => {
const typeFilterItems = grid.querySelectorAll('.product-grid-filter-item[data-filter]');
const productItems = grid.querySelectorAll('.product-grid-item');

if (typeFilterItems.length && productItems.length) {
typeFilterItems.forEach((btn) => {
btn.addEventListener('click', () => {
const selected = btn.dataset.filter;

typeFilterItems.forEach((b) => b.classList.remove('active-era-background', 'is-active'));
btn.classList.add('active-era-background', 'is-active');

productItems.forEach((item) => {
const isSfSeries = item.dataset.sfSeries === 'true';
const show = selected === 'all' || (!isSfSeries && item.dataset.category === selected);
item.style.display = show ? '' : 'none';
});
});
});
}

// ── Era filters (Core Collection) ───────────────────────────────
const eraFilterItems = grid.querySelectorAll('.product-grid-filter-item[data-era-filter]');

if (eraFilterItems.length && productItems.length) {
eraFilterItems.forEach((btn) => {
btn.addEventListener('click', () => {
const selected = btn.dataset.eraFilter; // 'all' | 'sfii' | 'sf6'

// Remove active state from all era buttons
eraFilterItems.forEach((b) => b.classList.remove('is-active'));

// Add is-active to clicked button — CSS handles the colour
// based on the era-sfii / era-sf6 / era-all class already on it
btn.classList.add('is-active');

// Show / hide products by data-era attribute
productItems.forEach((item) => {
const isSfSeries = item.dataset.sfSeries === 'true';
const show = selected === 'all' || (selected === 'sf-series' ? isSfSeries : item.dataset.era === selected && !isSfSeries);
item.style.display = show ? '' : 'none';
});
});
});
}

const urlEra = new URLSearchParams(window.location.search).get('era');
if (urlEra && eraFilterItems.length) {
const target = [...eraFilterItems].find(
(btn) => btn.dataset.eraFilter === urlEra.toLowerCase()
);
if (target) target.click();
}
});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('contact-form');
    var first = document.getElementById('ContactFirstName');
    var last = document.getElementById('ContactLastName');
    var combined = document.getElementById('contact-full-name');

    if (!form || !combined) return;

    form.addEventListener('submit', function () {
      var a = first ? first.value.trim() : '';
      var b = last ? last.value.trim() : '';
      combined.value = [a, b].filter(Boolean).join(' ');
    });
  })();
  const form = document.getElementById("contact-form");
  const successMsg = document.getElementById("form-success");
  const errorMsg = document.getElementById("form-error");
  const submitBtn = document.getElementById("submit-btn");
  
  const firstName = document.getElementById("ContactFirstName");
  const lastName = document.getElementById("ContactLastName");
  const fullName = document.getElementById("contact-full-name");
  
  // Auto combine full name
  function updateFullName() {
  fullName.value = `${firstName.value} ${lastName.value}`.trim();
  }
  
  firstName.addEventListener("input", updateFullName);
  lastName.addEventListener("input", updateFullName);
  
  // Submit handler
  form.addEventListener("submit", async (e) => {
  e.preventDefault();
  
  successMsg.style.display = "none";
  errorMsg.style.display = "none";
  
  submitBtn.classList.add("loading");
  submitBtn.textContent = "Sending...";
  
  const formData = new FormData(form);
  
  try {
  const res = await fetch("https://streetfighter-backend.onrender.com/contact", {
  method: "POST",
  body: formData
  });
  
  if (res.ok) {
  form.reset();
  submitBtn.textContent = "Sent ✓";
  successMsg.style.display = "block";
  
  setTimeout(() => {
  submitBtn.textContent = "Send Message";
  submitBtn.classList.remove("loading");
  }, 2000);
  } else {
  throw new Error();
  }
  } catch (err) {
  errorMsg.style.display = "block";
  submitBtn.textContent = "Send Message";
  submitBtn.classList.remove("loading");
  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["empty-limited"]) return;
  try {
    
const popupOverlay = document.querySelector('.popup-overlay');
const popup = document.querySelector('.popup');

if (popupOverlay && popup) {
const openPopup = () => {
popupOverlay.hidden = false;
document.body.style.overflow = 'hidden';
};

const closePopup = () => {
popupOverlay.hidden = true;
document.body.style.overflow = '';
};

const searchParams = new URLSearchParams(window.location.search);

if (searchParams.get('popup') === 'early-access') {
openPopup();
}

popupOverlay.addEventListener('click', (event) => {
if (event.target === popupOverlay) {
closePopup();
}
});

document.addEventListener('keydown', (event) => {
if (event.key === 'Escape' && popupOverlay.hidden === false) {
closePopup();
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const overlay = document.querySelector('.global-popup-overlay');
    if (!overlay) return;

    const popup = overlay.querySelector('.popup');
    const storageKey = 'sf-site-popup-seen';

    const openPopup = () => {
      try {
        sessionStorage.setItem(storageKey, '1');
      } catch {
        // Session storage may be unavailable in some contexts.
      }

      overlay.hidden = false;
      document.body.classList.add('has-site-popup');
      document.body.style.overflow = 'hidden';
    };

    const closePopup = () => {
      overlay.hidden = true;
      document.body.classList.remove('has-site-popup');
      document.body.style.overflow = '';
    };

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        closePopup();
      }
    });

    const closeBtn = overlay.querySelector('.popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closePopup();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && overlay.hidden === false) {
        closePopup();
      }
    });

    if (popup) {
      popup.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    const scheduleInitialOpen = () => {
      window.setTimeout(() => {
        try {
          if (sessionStorage.getItem(storageKey) !== '1') {
            openPopup();
          }
        } catch {
          openPopup();
        }
      }, 5000);
    };

    if (document.readyState === 'complete') {
      scheduleInitialOpen();
    } else {
      window.addEventListener('load', scheduleInitialOpen, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
'use strict';

const VISIBLE_LIMIT = 4;
document.querySelectorAll('[data-home-product-grid]').forEach((grid) => {

// ── Type filters (non-core collections) ──────────────────────────
const typeFilterItems = grid.querySelectorAll('.product-grid-filter-item[data-filter]');
const allProductItems = [...grid.querySelectorAll('.product-grid-item')];

if (typeFilterItems.length && allProductItems.length) {
typeFilterItems.forEach((btn) => {
btn.addEventListener('click', () => {
const selected = btn.dataset.filter;

typeFilterItems.forEach((b) => b.classList.remove('active-era-background', 'is-active'));
btn.classList.add('active-era-background', 'is-active');

allProductItems.forEach((item) => {
const isSfSeries = item.dataset.sfSeries === 'true';
const show = selected === 'all' || (!isSfSeries && item.dataset.category === selected);
item.style.display = show ? '' : 'none';
});
});
});
}

// ── Era filters (Core Collection) ────────────────────────────────
const eraFilterItems = grid.querySelectorAll('.product-grid-filter-item[data-era-filter]');

if (eraFilterItems.length && allProductItems.length) {
eraFilterItems.forEach((btn) => {
btn.addEventListener('click', () => {
const selected = btn.dataset.eraFilter; // 'all' | 'sfii' | 'sf6'

// Swap active class — CSS handles colour via era-sfii / era-sf6 / era-all
eraFilterItems.forEach((b) => b.classList.remove('is-active'));
btn.classList.add('is-active');

// Hide everything first
allProductItems.forEach((item) => (item.style.display = 'none'));

if (selected === 'all') {
// Show first 2 of each era
const sfii = allProductItems.filter((i) => i.dataset.era === 'sfii');
const sf6 = allProductItems.filter((i) => i.dataset.era === 'sf6');
sfii.slice(0, 2).forEach((i) => (i.style.display = ''));
sf6.slice(0, 2).forEach((i) => (i.style.display = ''));
} else if (selected === 'sf-series') {
allProductItems
    .filter((i) => i.dataset.sfSeries === 'true')
    .slice(0, VISIBLE_LIMIT)
    .forEach((i) => (i.style.display = ''));
} else {
// Show up to 4 of the selected era
allProductItems
.filter((i) => i.dataset.era === selected && i.dataset.sfSeries !== 'true')
.slice(0, VISIBLE_LIMIT)
.forEach((i) => (i.style.display = ''));
}
});
});
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-header"]) return;
  try {
    
  (function () {
    var MOBILE_BREAKPOINT = 980;
    var header = document.querySelector('.landing-header');
    if (!header) return;

    var toggle = header.querySelector('.header-menu-toggle');
    var menu = header.querySelector('.header-mobile-menu');
    var overlay = header.querySelector('.header-menu-overlay');
    var mobileLinks = header.querySelectorAll('.header-mobile-menu a');
    if (!toggle || !menu || !overlay) return;

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function openMenu() {
      if (!isMobile()) return;
      header.classList.add('is-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close navigation menu');
      menu.hidden = false;
      overlay.hidden = false;
    }

    function closeMenu() {
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open navigation menu');
      menu.hidden = true;
      overlay.hidden = true;
    }

    toggle.addEventListener('click', function () {
      if (header.classList.contains('is-menu-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    overlay.addEventListener('click', closeMenu);

    mobileLinks.forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });

    document.addEventListener('click', function (event) {
      if (!isMobile()) return;
      if (!header.classList.contains('is-menu-open')) return;
      if (header.contains(event.target)) return;
      closeMenu();
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) closeMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limited"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const limitedCollectionGrids = document.querySelectorAll('.limited-collection-grid');
    const eraFilterButtons = document.querySelectorAll('.filter-button[data-era-filter]');

    eraFilterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedEra = button.dataset.eraFilter;

        eraFilterButtons.forEach((item) => item.classList.remove('active-era-background'));
        button.classList.add('active-era-background');

        limitedCollectionGrids.forEach((grid) => {
          const gridEra = grid.dataset.collectionEra || 'sf2';

          if (selectedEra == 'all' || gridEra == selectedEra) {
            grid.style.display = '';
          } else {
            grid.style.display = 'none';
          }
        });
      });
    });

    limitedCollectionGrids.forEach((grid) => {
      const filterItems = grid.querySelectorAll('.product-grid-filter-item');
      const productItems = grid.querySelectorAll('.product-grid-item');

      if (!filterItems.length || !productItems.length) return;

      filterItems.forEach((filterItem) => {
        filterItem.addEventListener('click', () => {
          const selectedFilter = filterItem.dataset.filter;

          filterItems.forEach((item) => item.classList.remove('active-era-background'));
          filterItem.classList.add('active-era-background');

          productItems.forEach((productItem) => {
            if (selectedFilter === 'all' || productItem.dataset.category === selectedFilter) {
              productItem.style.display = '';
            } else {
              productItem.style.display = 'none';
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  const filterItems = document.querySelectorAll('.product-grid-filter-item');
  const productItems = document.querySelectorAll('.product-grid-item');

  if (filterItems.length && productItems.length) {
    filterItems.forEach((filterItem) => {
      filterItem.addEventListener('click', () => {
        const selectedFilter = filterItem.dataset.filter;

        filterItems.forEach((item) => item.classList.remove('active-era-background'));
        filterItem.classList.add('active-era-background');

        productItems.forEach((productItem) => {
          if (selectedFilter == 'all' || productItem.dataset.category == selectedFilter) {
            productItem.style.display = '';
          } else {
            productItem.style.display = 'none';
          }
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
      (() => {
      'use strict';

      // ── Sanitise plain text before inserting into the DOM ──────────────
      // Used for any server-derived string we set as textContent (belt-and-
      // braces — textContent is already safe, but explicit is better).
      const sanitiseText = (str) => String(str ?? '').trim();

      // ── Helpers ────────────────────────────────────────────────────────
      const CART_REFRESH_TIMEOUT = 1800; // ms before submit button resets

      document.querySelectorAll('.product-section').forEach((section) => {
      const form = section.querySelector('.product-form');
      const mainMedia = section.querySelector('.product-main-media');
      const mainImg = section.querySelector('.product-main-media img');
      const thumbBtns = [...section.querySelectorAll('.product-thumb')];
      const prevBtn = section.querySelector('.product-image-nav__button--prev');
      const nextBtn = section.querySelector('.product-image-nav__button--next');
      const variantInputs = [...section.querySelectorAll('.product-variants input[type="radio"]')];
      const quantityWrap = section.querySelector('[data-product-quantity]');
      const quantityInput = section.querySelector('.product-quantity__input');
      const quantityButtons = [...section.querySelectorAll('.product-quantity__button')];
      const priceNode = section.querySelector('.product-current-price');
      const submitBtn = section.querySelector('.product-form .button-filled');
      const statusNode = section.querySelector('.product-form-status');
      const defaultBtnText = 'Add to bag';
      const goToBagText = 'Go to bag';
      const cartState = {
      isAdded: false,
      variantId: null,
      updating: false
      };

      const getSelectedVariantInput = () => section.querySelector('.product-variants input[type="radio"]:checked');

      const getSelectedVariantId = () => Number(getSelectedVariantInput()?.value || form?.querySelector('input[type="hidden"][name="id"]')?.value || 0);

      const clampQuantity = (value) => Math.max(0, Number(value || 0));

      const getQuantity = () => {
      if (!quantityInput) return 1;
      return Math.max(1, Number(quantityInput.value || 1));
      };

      const setQuantity = (value) => {
      if (!quantityInput) return;
      const nextValue = Math.max(1, Number(value || 1));
      quantityInput.value = String(nextValue);
      };

      const setSubmitState = (isAdded, unavailable = false) => {
      if (!submitBtn) return;
      const needsSize = variantInputs.length > 0 && !getSelectedVariantInput();
      if (needsSize) {
        unavailable = variantInputs.every(input => input.disabled);
        submitBtn.classList.remove('is-in-cart');
        if (quantityWrap) quantityWrap.hidden = true;
        submitBtn.textContent = unavailable ? 'Sold out' : defaultBtnText;
        submitBtn.type = 'submit';
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        return;
      }
      submitBtn.classList.toggle('is-in-cart', isAdded && !unavailable);
      if (quantityWrap) {
      quantityWrap.hidden = !(isAdded && !unavailable);
      }

      if (unavailable) {
      submitBtn.textContent = 'Sold out';
      submitBtn.type = 'submit';
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      return;
      }

      submitBtn.textContent = isAdded ? goToBagText : defaultBtnText;
      submitBtn.type = isAdded ? 'button' : 'submit';
      submitBtn.disabled = false;
      submitBtn.setAttribute('aria-disabled', 'false');
      };

      const resetCartState = (unavailable = false) => {
      cartState.isAdded = false;
      cartState.variantId = null;
      setSubmitState(false, unavailable);
      };

      const refreshCartCountFromData = (data) => {
      const countNode = document.querySelector('.header-cart-count');
      if (!countNode) return;
      countNode.textContent = String(data.item_count ?? 0);
      countNode.hidden = (data.item_count ?? 0) === 0;
      };

      const fetchCart = async () => {
      const res = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Unable to load cart.');
      return res.json();
      };

      const syncQuantityToCart = async (nextQuantity) => {
      if (!cartState.isAdded || !cartState.variantId || cartState.updating) return;
      cartState.updating = true;

      try {
      const cartData = await fetchCart();
      const matchIndex = cartData.items.findIndex((item) => Number(item.variant_id) === Number(cartState.variantId));
      if (matchIndex < 0) {
      resetCartState();
      return;
      }

      const quantity = clampQuantity(nextQuantity);
      const res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
      },
      body: JSON.stringify({
      line: matchIndex + 1,
      quantity
      })
      });

      if (!res.ok) throw new Error('Unable to update quantity.');

      const data = await res.json();
      refreshCartCountFromData(data);

      if (quantity <= 0) {
      resetCartState();
      setQuantity(1);
      }
      } catch (error) {
      showStatus(error instanceof Error ? error.message : 'Unable to update quantity.', 'error');
      } finally {
      cartState.updating = false;
      }
      };

      quantityButtons.forEach((button) => {
      button.addEventListener('click', () => {
      if (!quantityInput) return;
      const step = Number(button.dataset.quantityStep || 0);
      const currentValue = getQuantity();
      const nextValue = Math.max(1, currentValue + step);
      setQuantity(nextValue);

      if (cartState.isAdded) {
      syncQuantityToCart(nextValue);
      }
      });
      });

      quantityInput?.addEventListener('change', () => {
      const nextValue = Math.max(1, Number(quantityInput.value || 1));
      setQuantity(nextValue);

      if (cartState.isAdded) {
      syncQuantityToCart(nextValue);
      }
      });

      // ── Thumbnail / main image swap ──────────────────────────────────
      const activateThumb = (btn) => {
      if (!btn) return;
      thumbBtns.forEach((t) => t.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (btn.closest('.product-thumbs--track')) {
      btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      };

      const setMainImage = (imageUrl, imageId) => {
      if (!mainImg || !imageUrl) return;

      // Build a proper srcset so responsive images keep working
      const baseUrl = imageUrl.replace(/(_\d+x\d*)\.(jpg|jpeg|png|webp|gif)/i, '.$2');
      mainImg.src = imageUrl;
      mainImg.srcset = `${imageUrl} 2000w`;
      mainImg.sizes = '(max-width: 980px) 100vw, 535px';

      // Sync active thumb if we have an imageId
      if (imageId) {
      const match = thumbBtns.find((b) => b.dataset.imageId === String(imageId));
      activateThumb(match ?? null);
      }
      };

      const getActiveImageIndex = () => {
      const activeIndex = thumbBtns.findIndex((btn) => btn.classList.contains('is-active'));
      return activeIndex >= 0 ? activeIndex : 0;
      };

      const showImageAt = (index) => {
      if (!thumbBtns.length) return;
      const nextIndex = (index + thumbBtns.length) % thumbBtns.length;
      const targetBtn = thumbBtns[nextIndex];
      if (!targetBtn) return;
      activateThumb(targetBtn);
      setMainImage(targetBtn.dataset.imageUrl, targetBtn.dataset.imageId);
      };

      const showPreviousImage = () => {
      showImageAt(getActiveImageIndex() - 1);
      };

      const showNextImage = () => {
      showImageAt(getActiveImageIndex() + 1);
      };

      prevBtn?.addEventListener('click', showPreviousImage);
      nextBtn?.addEventListener('click', showNextImage);

      if (mainMedia && thumbBtns.length > 1) {
      let startX = 0;
      let startY = 0;
      let tracking = false;

      mainMedia.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      tracking = true;
      startX = touch.clientX;
      startY = touch.clientY;
      }, { passive: true });

      mainMedia.addEventListener('touchend', (event) => {
      if (!tracking) return;
      tracking = false;

      const touch = event.changedTouches[0];
      if (!touch) return;

      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;

      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;

      if (deltaX < 0) {
      showNextImage();
      } else {
      showPreviousImage();
      }
      }, { passive: true });
      }

      thumbBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
      activateThumb(btn);
      setMainImage(btn.dataset.imageUrl, btn.dataset.imageId);
      });
      });

      // ── Variant change → price + image ──────────────────────────────
      variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
      if (!input.checked) return;

      if (priceNode && input.dataset.price) {
      priceNode.textContent = sanitiseText(input.dataset.price);
      }

      setQuantity(1);
      resetCartState(input.disabled);
      cartState.variantId = getSelectedVariantId();

      });
      });

      // ── Status message helper ────────────────────────────────────────
      const showStatus = (message, type /* 'success' | 'error' */) => {
      if (!statusNode) return;
      statusNode.textContent = sanitiseText(message);
      statusNode.className = `product-form-status body-sm muted-text is-visible is-${type}`;
      statusNode.hidden = false;
      };

      const clearStatus = () => {
      if (!statusNode) return;
      statusNode.hidden = true;
      statusNode.textContent = '';
      statusNode.className = 'product-form-status body-sm muted-text';
      };

      // ── Cart count refresh ───────────────────────────────────────────
      const refreshCartCount = async (cartUrl) => {
      try {
      const res = await fetch(`${cartUrl}.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
      });
      if (!res.ok) return;
      const data = await res.json();
      const countNode = document.querySelector('.header-cart-count');
      if (countNode) {
      countNode.textContent = String(data.item_count ?? 0);
      countNode.hidden = (data.item_count ?? 0) === 0;
      }
      } catch {
      // Non-critical — silently swallow
      }
      };

      // ── Add-to-cart submit ───────────────────────────────────────────
      if (form && submitBtn && statusNode) {
      const cartAddUrl = form.getAttribute('action') || '/cart/add';
      const cartUrl = cartAddUrl.replace(/\/add$/, '');

      submitBtn.addEventListener('click', () => {
      if (cartState.isAdded) {
      window.location.href = '/cart';
      }
      });

      form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (submitBtn.disabled) return; // guard double-submit

      const selectedInput = getSelectedVariantInput();
      if (variantInputs.length && (!selectedInput || selectedInput.disabled)) {
        resetCartState(selectedInput?.disabled ?? false);
        return;
      }
      if (!getSelectedVariantId()) return;
      const selectedLabel = selectedInput
      ? form.querySelector(`label[for="${CSS.escape(selectedInput.id)}"]`)
      : null;
      const variantTitle = selectedLabel ? sanitiseText(selectedLabel.textContent) : '';
      const quantity = getQuantity();

      form.classList.add('is-loading');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
      clearStatus();

      try {
      const res = await fetch(`${cartAddUrl}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
      });

      if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Unable to add item to cart.');
      }

      const addedItem = await res.json().catch(() => ({}));
      const addedQuantity = Number(addedItem.quantity || quantity || 1);

      cartState.isAdded = true;
      cartState.variantId = getSelectedVariantId();
      setQuantity(addedQuantity);
      setSubmitState(true, false);

      const successMsg = variantTitle
      ? `${variantTitle} added to bag. Go to bag or adjust quantity.`
      : 'Added to bag. Go to bag or adjust quantity.';

      showStatus(successMsg, 'success');

      await refreshCartCount(cartUrl);

      } catch (err) {
      const msg = err instanceof Error ? err.message : 'Unable to add item to cart.';
      showStatus(msg, 'error');
      resetCartState(selectedInput?.disabled ?? false);
      } finally {
      form.classList.remove('is-loading');
      }
      });
      }

      // Start every size picker without an implicit/default variant selection.
      if (variantInputs.length) {
        variantInputs.forEach(input => { input.checked = false; });
        resetCartState();
      }
      if (quantityWrap) {
      quantityWrap.hidden = true;
      }
      // Size guide modal: intercept existing Size guide anchor and show product-specific table in a modal
      (function() {
        const sizeGuideLink = section.querySelector('a[href$="/pages/size-guide"], a[href$="/pages/size-guide/"]');
        if (!sizeGuideLink) return;
        const KEY = (sizeGuideLink.dataset.sizeGuideKey || '').trim().toLowerCase();
        const NAME = (sizeGuideLink.dataset.sizeGuideName || '').trim();

        const createModal = (html) => {
          const backdrop = document.createElement('div');
          backdrop.className = 'product-size-guide-modal';
          Object.assign(backdrop.style, { position: 'fixed', inset: '0', background: 'rgba(3,3,3,0.6)', zIndex: '1200', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' });
          const dialog = document.createElement('div');
          dialog.setAttribute('role','dialog'); dialog.setAttribute('aria-modal','true');
          Object.assign(dialog.style, { background: 'var(--card-color)', border: '1px solid var(--border-color)', borderRadius: '8px', maxWidth: '960px', width: '100%', padding: '14px', overflow: 'hidden', boxSizing: 'border-box' });
          const closeBtn = document.createElement('button'); closeBtn.setAttribute('aria-label','Close'); closeBtn.textContent='×';
          Object.assign(closeBtn.style, { position: 'absolute', right: '10px', top: '8px', width: '36px', height: '36px', fontSize: '20px', background: 'transparent', border: '0', cursor: 'pointer' });
          const content = document.createElement('div'); content.className='product-size-guide-content'; Object.assign(content.style, { overflow: 'auto', maxHeight: '70vh', paddingRight: '6px' }); content.innerHTML = html;
          // make any table responsive
          const tw = content.querySelector('.size-guide-table-wrap'); if (tw) { tw.style.overflowX='auto'; tw.style.webkitOverflowScrolling='touch'; const t = tw.querySelector('.size-guide-table'); if (t) { t.style.minWidth='0'; t.style.width='100%'; t.style.tableLayout='auto'; } }
          dialog.appendChild(closeBtn); dialog.appendChild(content); backdrop.appendChild(dialog);
          const remove = () => { backdrop.remove(); document.removeEventListener('keydown', onKey); try{ sizeGuideLink.focus(); }catch(e){} };
          const onKey = (e) => { if (e.key === 'Escape') remove(); };
          closeBtn.addEventListener('click', remove); backdrop.addEventListener('click', (ev)=>{ if (ev.target===backdrop) remove(); }); document.addEventListener('keydown', onKey);
          document.body.appendChild(backdrop); closeBtn.focus();
        };

        sizeGuideLink.addEventListener('click', async (ev) => {
          ev.preventDefault();
          try {
            const res = await fetch('/pages/size-guide'); if (!res.ok) throw new Error('Unable to load size guide');
            const text = await res.text(); const parser = new DOMParser(); const doc = parser.parseFromString(text, 'text/html');
            // try match by heading text first
            let found = null;
            if (NAME) {
              const cards = Array.from(doc.querySelectorAll('.size-guide-card'));
              const target = NAME.trim().toLowerCase();
              for (const c of cards) {
                const h2 = c.querySelector('h2'); const heading = h2 ? (h2.textContent||'').trim().toLowerCase() : '';
                if (heading && heading === target) { found = c.querySelector('.size-guide-table-wrap') || c; break; }
                const aw = c.querySelector('.size-guide-table-wrap'); const aria = aw ? (aw.getAttribute('aria-label')||'').trim().toLowerCase() : '';
                if (aria && aria === target) { found = aw; break; }
              }
            }
            // fallback: pick by order
            if (!found && KEY) {
              const order = { blaster:0, cruiser:1, creator:2, changer:3, cultivator:4 };
              const cards = doc.querySelectorAll('.size-guide-card'); const idx = order[KEY]; const c = cards && cards[idx]; if (c) found = c.querySelector('.size-guide-table-wrap') || c;
            }
            if (!found) found = doc.querySelector('.size-guide-table-wrap') || doc.querySelector('.size-guide-card');
            const html = found ? (found.querySelector ? (found.querySelector('.size-guide-table-wrap') ? found.querySelector('.size-guide-table-wrap').innerHTML : found.innerHTML) : found.innerHTML) : '<p>Size guide not available.</p>';
            createModal(html);
          } catch (err) { console.error('Size guide error', err); window.location.href = sizeGuideLink.href; }
        });
      })();
      });
      })();
      
  } catch(e) { console.error(e); }
})();
})();
